export interface AuthInterface{
    logIn(username: string, password: string, remember?: boolean): Promise<boolean>;
    logOut(): Promise<boolean>;
    check(): Promise<boolean>;
}

export enum AuthResultCode {
    ExternalLoginAlreadyInUse = -16,
    OnlyOneExternalLoginAllowed = -17,
    OnlyExternalLoginAllowed = -18
}
